import React, { useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"

import ContactItem from "../../components/ContactItem"
import { СONTACTS } from "../../mocks/contacts"
import { formatIosContacts } from "../../utils/formatters"
import {
  AlphabetTitle,
  ClientContainer,
  ContentContainer,
  ScrollingContainer,
  SearchInput,
  StyledButton,
} from "./styled"
import { useContactsByAlphabet } from "./hooks/useContactsByAlphabet"
import { setRecipient } from "../../store/slices/c2cSlice"
import { useContactSearchInput } from "../../hooks/useContactsSearchInput"
import {
  filterContactsByPhoneAndName,
  isPhoneNumber,
} from "../../utils/contacts"
import LoadingOverlay from "../../components/LoadingOverlay"
import { ContactsListProps } from "./props"
import { RootState } from "../../store/store"

const ContactsList = ({
  handleSelectContact,
  isLoading: isLoadingDefaultBank,
  handleClickNext,
}: ContactsListProps) => {
  const dispatch = useDispatch()

  const bankObject = {
    bankId: "",
    logoUrl: "",
    title: "",
  }

  const { contactQuery, onContactQueryChange } = useContactSearchInput()

  const contacts = useMemo(() => formatIosContacts(СONTACTS), [СONTACTS])
  const filteredContacts = useMemo(
    () => filterContactsByPhoneAndName(contacts, contactQuery),
    [contacts, contactQuery],
  )
  const { contactsByAlphabet, sortedAlphabet } =
    useContactsByAlphabet(filteredContacts)
  const transferTo = useSelector(
    (state: RootState) => state.transferForm.recipient,
  )

  const handleChangeQuery = (
    evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = evt.target
    onContactQueryChange(value)
    dispatch(setRecipient({ ...transferTo, phone: value }))
  }

  const isPhoneValid = isPhoneNumber(contactQuery)

  if (isLoadingDefaultBank) {
    return <LoadingOverlay />
  }

  return (
    <ContentContainer>
      <SearchInput
        placeholder="Имя, номер телефона"
        value={contactQuery}
        onChange={handleChangeQuery}
      />

      <ScrollingContainer>
        {sortedAlphabet.map((letter) => (
          <div key={letter}>
            <AlphabetTitle variant="h4Bold">{letter}</AlphabetTitle>
            <ClientContainer>
              {contactsByAlphabet[letter]?.map((contact) => (
                <div key={contact.id!}>
                  <ContactItem
                    name={contact.name!}
                    desciption={contact.phone}
                    onClick={() => handleSelectContact(contact)}
                    bank={bankObject}
                    iconType="contact"
                  />
                </div>
              ))}
            </ClientContainer>
          </div>
        ))}
      </ScrollingContainer>

      {isPhoneValid && (
        <StyledButton
          variant="contained"
          disabled={!isPhoneValid}
          onClick={handleClickNext}
        >
          Продолжить
        </StyledButton>
      )}
    </ContentContainer>
  )
}

export default ContactsList
